import { render } from "./MeasureList.vue?vue&type=template&id=0716bca2&scoped=true"
import script from "./MeasureList.vue?vue&type=script&lang=js"
export * from "./MeasureList.vue?vue&type=script&lang=js"

import "./MeasureList.vue?vue&type=style&index=0&id=0716bca2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0716bca2"]])

export default __exports__